import PIECard from '@src/shared/components/PIECard';
import React from 'react';
import style from './DasboardStatisticsBannerDesktop.module.scss';
import PIEText from '@src/shared/components/PIEText';
import { useTranslation } from 'react-i18next';
import TagNew from '../DashboardCustomTag/components/TagNew';
import { IconChartIncreaseLarge } from '@justeattakeaway/pie-icons-react';
interface componentProps {
  onClick?: () => void;
}
const DashboardStatisticsBannerDesktop = ({ onClick }: componentProps) => {
  const { t } = useTranslation();
  return (
    <PIECard
      className={`${style.DashboardStatisticsBannerDesktop} dashboard-statistics-button`}
      onClick={() => onClick && onClick()}
    >
      <PIEText
        text={
          <>
            {t('deliverydata.MENU_TITLE')}{' '}
            <TagNew className={style.newBadge}>
              <PIEText
                text={t('deliverydata.MENU_TITLE_TAG')}
                color="var(--xds-color-content-light)"
                size="var(--xds-font-size-12)"
                fontWeight="var(--xds-font-weight-regular)"
              />
            </TagNew>
            <IconChartIncreaseLarge size={32} className={style.icon} />
          </>
        }
        color="var(--xds-color-content-default)"
        size="var(--xds-font-size-16)"
        fontWeight="var(--xds-font-weight-bold)"
      />
    </PIECard>
  );
};

export default DashboardStatisticsBannerDesktop;
